// extracted by mini-css-extract-plugin
module.exports = {"bar":"_5D3JpqRe","description":"_5D3KwXgf","form":"_5D2u6HE9"};